<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <RsljigouInternal :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="已部分完成" value="2"></el-option>
              <el-option label="已全部完成" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clicksearch" placeholder="请输入材料编号"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->
        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="JigouName" label="所属公司名称" min-width="5%"></el-table-column>
          <el-table-column prop="Orderid" label="订单号" min-width="10%"></el-table-column>
          <el-table-column prop="Orderstatuss" label="订单状态" min-width="5%"></el-table-column>
          <el-table-column prop="Parentname" label="项目名称" min-width="6%"></el-table-column>
          <el-table-column prop="Bomsn" label="材料编号" min-width="6%"></el-table-column>
          <el-table-column prop="Productname" label="材料名称" min-width="6%"></el-table-column>
          <el-table-column prop="Manufacturer" label="生产厂家" min-width="5%"></el-table-column>
          <el-table-column prop="Receivenum" label="入库1(交付)" min-width="8%"></el-table-column>
          <el-table-column prop="Numruku" label="入库2(退货/退货入账/换货)" min-width="10%">
            <template slot-scope="scope">
              <span style="color: #67c23a;font-weight: 700;">{{ scope.row.Numruku }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Numchuku" label="出库" min-width="8%">
            <template slot-scope="scope">
              <span style="color: #409eff;font-weight: 700;">{{ scope.row.Numchuku }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="NumKuCun" label="库存(入库1+入库2-出库)" min-width="8%"></el-table-column>
          <el-table-column prop="Receivetime" label="最后一次交货时间" min-width="10%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="10%"></el-table-column>
          <el-table-column prop="operation" label="操作" header-align="center" align="center" min-width="15%">
            <template slot="header" slot-scope="scope">
              <div class="mytitle">操作</div>
            </template>
            <template v-slot="scope">
              <el-button type="success" size="mini" v-if="SubRule_MadeManagement_Ruku1" @click="click_ruku(scope.row)">入库2</el-button>
              <el-button type="primary" size="mini" v-if="SubRule_MadeManagement_Chuku" @click="click_chuku(scope.row)">出库</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->
        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="5"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="库存操作" name="second" disabled="disabled">
        <KucunManagementOperation ref="SubVuesecond" v-on:triggerFunc="BackToFirst"></KucunManagementOperation>
      </el-tab-pane>

  </el-tabs>
  </div>
</template>

<script>
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import KucunManagementOperation from '@/componentsSubVue/KucunManagementOperation.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    RsljigouInternal,
    KucunManagementOperation
  },
  name: 'MyKucunManagement',
  data () {
    return {
      activeName: 'first',
      addForm: {
        manufacturer: '',
        targetnum: '',
        endtime: ''
      },
      keywords: {
        jigouid: '-1',
        jigouname: '',
        orderid: '',
        orderstatus: '-1',
        bomsn: ''
      },
      dataList: [],
      dataListnum: 0,
      delaydialog: false,
      delayForm: {
        id: '',
        endtime: ''
      },
      targetnumdialog: false,
      targetnumForm: {
        id: '',
        targetnum: ''
      },
      submitnumdialog: false,
      submitnumForm: {
        id: '',
        num: ''
      },
      selectedPageNo: 1,
      SubRule_MadeManagement_Ruku1: false,
      SubRule_MadeManagement_Chuku: false
    }
  },
  mounted () {
    this.apigetmadeordernumkucun()
    this.apigetmadeorderlistkucun()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_Ruku1', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_Ruku1 = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_Chuku', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_Chuku = true
      }
    })
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
      this.apigetmadeordernumkucun()
      this.apigetmadeorderlistkucun()
    },
    changeRsljigouInternal (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    click_ruku (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '入库2', orderid: row.Orderid, bomsn: row.Bomsn, operationtype: 123 })
    },
    click_chuku (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData({ name: '出库', orderid: row.Orderid, bomsn: row.Bomsn, operationtype: 456 })
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apigetmadeordernumkucun()
      this.apigetmadeorderlistkucun()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apigetmadeorderlistkucun()
    },
    apigetmadeordernumkucun: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getmadeordernumkucun, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apigetmadeorderlistkucun: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        bomsn: that.keywords.bomsn,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getmadeorderlistkucun, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditmadeordersubmitnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: this.submitnumForm.id,
        num: this.submitnumForm.num
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editmadeordersubmitnum, Qs.stringify(data))
        .then(function (response) {
          that.apigetmadeorderlistkucun()
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.submitnumdialog = false
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

.mytitle{
  color: #000000;
  font-weight:bold;
}

</style>
